import { forEach, get } from 'lodash'

export default class Address {

  // eslint-disable-next-line max-params
  constructor(address1, address2, city, state_name, zip_code, country) {
    this.address1 = address1
    this.address2 = address2
    this.city = city
    this.state_name = state_name
    this.zip_code = zip_code
    this.country = country

    const street = address2 ? `${address1} ${ address2}` : address1
    this.street = address2 ? `${address1} ${ address2}` : address1
    const locality = `${ city }, ${ state_name } ${ zip_code }`
    this.locality = locality
    this.singleLineFormat = `${ street }, ${locality} ${ country }`
  }

  static fromAttributes({
    address1,
    address2,
    city,
    zip_code,
    state_name,
    country,
  }) {
    return new Address(
      address1,
      address2,
      city,
      state_name,
      zip_code,
      country,
    )
  }

  static fromGoogleAddress(result) {
    // EXAMPLE RESULT:
    // {
    //   "address_components":[
    //     {
    //       "long_name":"34",
    //       "short_name":"34",
    //       "types":[
    //         "street_number"
    //       ]
    //     },
    //     {
    //       "long_name":"Goldenrod Circle",
    //       "short_name":"Goldenrod Cir",
    //       "types":[
    //         "route"
    //       ]
    //     },
    //     {
    //       "long_name":"Santa Rosa Beach",
    //       "short_name":"Santa Rosa Beach",
    //       "types":[
    //         "locality",
    //         "political"
    //       ]
    //     },
    //     {
    //       "long_name":"Walton County",
    //       "short_name":"Walton County",
    //       "types":[
    //         "administrative_area_level_2",
    //         "political"
    //       ]
    //     },
    //     {
    //       "long_name":"Florida",
    //       "short_name":"FL",
    //       "types":[
    //         "administrative_area_level_1",
    //         "political"
    //       ]
    //     },
    //     {
    //       "long_name":"United States",
    //       "short_name":"US",
    //       "types":[
    //         "country",
    //         "political"
    //       ]
    //     },
    //     {
    //       "long_name":"32459",
    //       "short_name":"32459",
    //       "types":[
    //         "postal_code"
    //       ]
    //     }
    //   ],
    //   "formatted_address":"34 Goldenrod Cir, Santa Rosa Beach, FL 32459, USA",
    //   "geometry":{
    //     "bounds":{
    //       "south":30.3214768,
    //       "west":-86.1453638,
    //       "north":30.32233009999999,
    //       "east":-86.1442672
    //     },
    //     "location":{
    //       "lat":30.3218602,
    //       "lng":-86.1449276
    //     },
    //     "location_type":"ROOFTOP",
    //     "viewport":{
    //       "south":30.3207618197085,
    //       "west":-86.14616448029152,
    //       "north":30.3234597802915,
    //       "east":-86.1434665197085
    //     }
    //   },
    //   "place_id":"ChIJ9THVBvDkk4gR0ZMKnUdlBnU",
    //   "types":[
    //     "premise"
    //   ]
    // }

    const formatted_address = result.formatted_address
    const address_components = result.address_components

    const addressComponentObject = {}
    forEach(address_components, (value1, index) => {
      forEach(address_components[index].types, (value2, _key) => {
        addressComponentObject[value2] = value1.short_name
      })
    })

    // NOTE: There is no 'address2' in the address_components object;
    // sub-premise information such as apartment, unit, or floor number must be handled separately.
    const street = get(addressComponentObject, 'street_number', null)
    const route = get(addressComponentObject, 'route', null)
    const address1 = street && route ? `${ street } ${ route }` : null

    // Google Maps API returns either a 'locality' or 'neighborhood' key for city information.
    const locality = get(addressComponentObject, 'locality', null)
    const neighborhood = get(addressComponentObject, 'neighborhood', null)
    const city = locality || neighborhood

    const attrs = {
      state_name: get(addressComponentObject, 'administrative_area_level_1', null),
      zip_code: get(addressComponentObject, 'postal_code', null),
      city: city,
      country: get(addressComponentObject, 'country', null),
      address1,
      formatted_address,
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
    }

    return attrs
  }

}
